<template>
  <div class="feedback feedback-ie-11" id="feedback">
    <span
      class="accessibility-hide-text"
      ref="acessiblityQuestionTitle"
      tabindex="1"
    >
      {{ labels.questionTitle }}
    </span>

    <h4 class="medium mb-5 pb-3" id="feedback-title" tabindex="2">
      {{ currentAnswered.feedback }}
    </h4>

    <span
      role="region"
      aria-live="assertive"
      class="accessibility-hide-text alert-warning"
    >
      {{ acessibilityAlertWarning }}
    </span>

    <div class="row mt-4 mb-3">
      <div class="col">
        <b-form-textarea
          :aria-label="labels.titleTextArea"
          id="feedback-text"
          class="feedback-description form-control"
          v-model="text"
          rows="5"
          tabindex="3"
        />
      </div>
    </div>

    <div class="d-flex" @keypress.enter.space="annonymous = !annonymous">
      <Switches
        id="switch-anonimous"
        tabindex="4"
        v-model="annonymous"
        type-bold="true"
        class="float-left m-2"
        theme="custom"
        color="primary"
        :title="labels.switchesTitle"
      ></Switches>
      <span aria-hidden="true">{{ resources.general.buttons.anonymous }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Switches from 'vue-switches'

export default {
  props: ['currentAnswered'],

  components: { Switches },

  mounted() {
    this.$refs.acessiblityQuestionTitle.focus()
  },

  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.feedback
    },
  },

  data() {
    return {
      feedback_answer: this.currentAnswered.feedback_answer || {
        text: undefined,
        is_annonymous: true,
      },
      text: this.currentAnswered.feedback_answer
        ? this.currentAnswered.feedback_answer.text
        : undefined,
      annonymous: this.currentAnswered.feedback_answer
        ? this.currentAnswered.feedback_answer.is_annonymous
        : true,
      acessibilityAlertWarning: '',
    }
  },

  watch: {
    text: function(val) {
      this.feedback_answer.text = val
      this.saveFeedback({ text: this.text, is_annonymous: this.annonymous })
    },
    annonymous: function(val) {
      this.acessibilityAlertWarning = val
        ? this.labels.acessibilityAlertWarningAnnonymous
        : this.labels.acessibilityAlertWarningNotAnnonymous

      this.feedback_answer.is_annonymous = val
      this.saveFeedback({ text: this.text, is_annonymous: this.annonymous })
    },
  },

  methods: {
    saveFeedback(selectFeedback) {
      if (!selectFeedback.text) {
        this.$emit('selectFeedback', null)
      } else {
        this.$emit('selectFeedback', selectFeedback)
      }
    },
  },
}
</script>

<style scoped lang="scss">
_:-ms-fullscreen,
:root .feedback-ie-11 {
  margin: 0 auto;
}

#feedback-title {
  @media (max-width: 767px) {
    margin: 0px !important;
  }
}

.feedback {
  display: block;
  flex-direction: column;
  flex-grow: 1;
  max-width: 1000px;
}

.feedback-description {
  min-height: 140px;
}

.alert-warning {
  position: absolute !important;
}
</style>
